import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

type SelectOption = {
  value: string;
  label: string;
};

type FormSelectFieldProps = {
  id: string;
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
};

export function FormSelectField({
  id,
  label,
  description,
  value,
  onChange,
  options,
  required = false,
  placeholder = 'Select...',
  disabled = false,
}: FormSelectFieldProps) {
  return (
    <div className="grid gap-1">
      <Label htmlFor={id} className="font-medium text-gray-900">
        {label}
        {required && <sup className="text-destructive">*</sup>}
      </Label>
      {description && (
        <p className="text-detail text-gray-500 leading-tight">{description}</p>
      )}
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger id={id} className="h-8">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
